import axios from 'axios';

const api = axios.create({
  // baseURL: 'https://scvc-backend.onrender.com/', // CHANGE THIS // https://scvs-backend-production.up.railway.app/
  baseURL: 'https://scvs-production-api.up.railway.app/', // CHANGE THIS // https://scvs-backend-production.up.railway.app/

  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('app_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear any existing auth data
      localStorage.removeItem('app_token');
      localStorage.removeItem('app_user');
      // Redirect to login
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
